/* global Viz */
import { addScriptAsync } from "./addScript";
import { getRootUrl } from "./context";

import versions from "./versions";

let vizLoader;

const nonce = document.currentScript?.nonce;

export function init(context, selector = "#graphviz") {
	(context || document).querySelectorAll(selector).forEach(async graphContainer => {
		if (typeof Viz === "undefined") {
			// initiate script loading once and wait till complete
			await (vizLoader ??= addScriptAsync({ src: `${getRootUrl()}/js/viz-${versions.viz}.min.js`, nonce }));
		}
		// 
		try {
			const vizInstance = await Viz.instance();
			const text = graphContainer.getAttribute("data-graph");
			const svgGraph = vizInstance.renderSVGElement(text);
			svgGraph.querySelectorAll("title").forEach(title => title.remove());
			graphContainer.replaceChildren(svgGraph);
		} catch (error) {
			graphContainer.replaceChildren(error.toString());
		}
	});
}
